<div class="aa-input-general gap-2 flex flex-col">
  @if (labelTop()) {
    <mat-label
      class="px-4"
      [ngClass]="
        formControlGeneral()?.invalid &&
        (formControlGeneral()?.touched || formControlGeneral()?.dirty)
          ? 'text-(--comp-input-label-error)'
          : 'text-(--comp-input-label-normal)'
      "
    >
      {{ isRequired(formControlGeneral()) ? (label() | translate) + '*' : (label() | translate) }}
    </mat-label>
  }

  <mat-form-field appearance="outline" floatLabel="always" class="w-full">
    <div class="flex items-center gap-1" [ngClass]="{ 'ml-2': TextPrefix() }">
      @if (TextPrefix()) {
        <div class="flex items-center gap-1">
          <mat-icon class="mb-0.5" matPrefix> {{ matTextPrefixIcon() }} </mat-icon>
        </div>
      }
      <input
        matInput
        [formControl]="getInputGeneral()"
        [thousandSeparator]="thousandSeparator()"
        [mask]="mask()"
        [prefix]="prefix()"
        [suffix]="suffix()"
        [type]="type() === 'password' ? (hidePassword() ? 'password' : 'text') : type()"
        [placeholder]="placeholder() | translate"
        [maxlength]="maxlength() > 0 ? maxlength() : 524288"
        [allowNegativeNumbers]="allowNegativeNumbers()"
        [pattern]="pattern()"
      />
    </div>

    @if (type() === 'password') {
      <button class="mr-1!" mat-icon-button matSuffix type="button">
        <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('required')) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('maxlength')) {
      <mat-error>
        {{
          'inputs.maxlength'
            | translate
              : { requiredLength: formControlGeneral()?.errors!['maxlength'].requiredLength }
        }}
      </mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('minlength')) {
      <mat-error>
        {{
          'inputs.minlength'
            | translate
              : { requiredLength: formControlGeneral()?.errors!['minlength'].requiredLength }
        }}
      </mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('min')) {
      <mat-error>
        {{ 'inputs.min' | translate: { min: formControlGeneral()?.errors!['min'].min } }}
      </mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('max')) {
      <mat-error>
        {{ 'inputs.max' | translate: { max: formControlGeneral()?.errors!['max'].max } }}
      </mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('pattern')) {
      <mat-error>{{ 'inputs.invalidFormat' | translate }}</mat-error>
    }
    @if (formControlGeneral() && formControlGeneral()?.hasError('email')) {
      <mat-error>{{ 'inputs.invalidFormat' | translate }}</mat-error>
    }
    @if (
      formControlGeneral() &&
      formControlGeneral()?.errors &&
      formControlGeneral()?.errors!['errorGeneral']
    ) {
      <mat-error>
        {{ formControlGeneral()?.errors!['errorGeneral'] }}
      </mat-error>
    }
  </mat-form-field>
</div>
